import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { DESKTOP_EXTRA_SMALL_WIDTH } from 'Styles/variables/sizes';

export const Container = styled(FlexContainer)`
  background: ${({ theme }) => theme.colors.grad_500};
  border: 1px solid ${({ theme }) => theme.colors.moon_500};
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_L};
  padding: ${({ theme: { sizing } }) => sizing.fds_size_16};
  max-height: 290px;
  width: 100%;
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    min-height: 140px;
  }
`;

export const Content = styled(FlexContainer)`
  img {
    width: ${({ theme: { sizing } }) => sizing.fds_size_56};
    height: ${({ theme: { sizing } }) => sizing.fds_size_56};
  }
`;

export const SpinnerContainer = styled(FlexContainer)`
  min-height: 118px;
`;
